/* eslint-disable react/destructuring-assignment, react/jsx-props-no-spreading */
import React from 'react';

import {
    commonDefaultProps,
    commonPropTypes,
    concatClassNames,
    ypUtilsToClassNames,
    filterProps,
} from '../../Abstrap/Abstrap';

const propTypes = {
    ...commonPropTypes,
};

const defaultProps = {
    ...commonDefaultProps,
};

const PageHeader = (props) => {
    let sizeClassName = 'c-page-header--s';
    switch (props.size) {
        case 'small':
            sizeClassName = 'c-page-header--s';
            break;
        case 'medium':
            sizeClassName = 'c-page-header--m';
            break;
        case 'large':
            sizeClassName = 'c-page-header--l';
            break;
        default:
            sizeClassName = 'c-page-header--s';
    }
    const classNames = [
        'c-page-header',
        sizeClassName,
        props.className,
        ...ypUtilsToClassNames(props.ypUtils),
    ];
    return (
        <props.componentClass
            className={concatClassNames(classNames)}
            {...filterProps(propTypes, props)}
        >
            {props.children}
        </props.componentClass>
    );
};

PageHeader.propTypes = propTypes;

PageHeader.defaultProps = defaultProps;

export default PageHeader;
